import { ref } from 'vue';
import { getSlideDetailStore } from '@/common/stores/slide-detail';

export const useInfraAdapterBase = () => {
  const isSlideDetailOpened = ref(false);
  const { addTabPanel } = getSlideDetailStore();
  return { isSlideDetailOpened, addTabPanel };
};
